import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

import { HttpEvent, TabNavEvent } from '../shared/events';
import { UserService } from './user.service';
import { DeviceService } from './device.service';

/**
 * Service for providing alert notifications to the user.  This service
 * uses Toastr for notifications.
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  
  constructor(readonly userService: UserService, private toastr: ToastrService, private device:DeviceService) {}

  private defaultConfig = {
    positionClass: 'toast-top-center',
    progressBar: true,
    disableTimeOut: false,
    closeButton: true,
    enableHtml: true
  } as IndividualConfig;

  notify(message: string) {
    // alert(message);

    this.toastr.info(message, undefined, this.defaultConfig);
  }
  info = (message: string) => this.notify(message);

  success = (message: string) => {
    this.toastr.success(message, undefined, this.defaultConfig);
  };

  successStickyWide = (message: string) => {
    let config = Object.assign({}, this.defaultConfig);
    config.progressBar = false;
    config.disableTimeOut = true;
    config.positionClass = 'toast-top-full-width';
    this.toastr.success(message, undefined, config);
  };

  error(message: string, title: string) {

    if (this.device.isDesktop){
      this.errorDesktop(message, title);
    }
    else{
      this.toastr.error(message, title, this.defaultConfig);
    }
    
  }

  private errorDesktop(message: string, title: string){
    let config = Object.assign({}, this.defaultConfig);
    config.positionClass = 'toast-top-full-width';
    this.toastr.error(message, undefined, config);

  }

  errorWide = (message: string, title?: string) => {
    let config = Object.assign({}, this.defaultConfig);
    config.positionClass = 'toast-top-full-width';
    this.toastr.error(message, title, config);
  };  

  public warning(message: string, title?: string): void {
    this.toastr.warning(message, title, this.defaultConfig);
  }

  notImplemented(text: string) {
    if (!text) {
      text = 'This feature is not implemented.';
    } else {
      text = `"${text}" is not implemented.`;
    }

    this.error(text, 'Not Implemented');
  }

  public showCommunicationError() {
    this.error('Unable to communicate with OutdoorAccess servers. Please check your internet connection and try again.', 'Communication Error');
  }
}

export type NotificationSource = string | TabNavEvent | HttpEvent;
